import type { RouterOutputs } from "~/utils/api"

export type TimelineWeek = RouterOutputs["allocation"]["getStoreTimeline"]["weeks"][number]

export type TimelineSummary = {
  current: TimelineWeek | null
  /** The median SKU count over the weeks with any SKU active. */
  typicalSkuCount: number
  peak: TimelineWeek | null
  /** The quietest week from the current week on, empty weeks included. */
  lowestAhead: TimelineWeek | null
}

export function summarizeTimeline(
  weeks: TimelineWeek[],
  currentWeekStart: string,
): TimelineSummary {
  const active = weeks
    .filter((week) => week.skuCount > 0)
    .map((week) => week.skuCount)
    .sort((a, b) => a - b)
  let peak: TimelineWeek | null = null
  let lowestAhead: TimelineWeek | null = null
  for (const week of weeks) {
    if (week.skuCount > (peak?.skuCount ?? 0)) peak = week
    const ahead = week.weekStart >= currentWeekStart
    if (ahead && (lowestAhead === null || week.skuCount < lowestAhead.skuCount)) lowestAhead = week
  }
  return {
    current: weeks.find((week) => week.weekStart === currentWeekStart) ?? null,
    typicalSkuCount: active.length === 0 ? 0 : active[Math.floor(active.length / 2)]!,
    peak,
    lowestAhead,
  }
}

/** At least 1, so it can divide. */
export function maxSkuCount(weeks: TimelineWeek[]): number {
  return weeks.reduce((max, week) => (week.skuCount > max ? week.skuCount : max), 1)
}
